var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.49999C17.1045 4.49999 18 5.39542 18 6.49999M11 3.70252L11.6851 2.99999C13.816 0.814702 17.2709 0.8147 19.4018 2.99999C21.4755 5.12659 21.5392 8.55379 19.5461 10.7599L13.8197 17.0981C12.2984 18.782 9.70154 18.782 8.18026 17.0981L2.45393 10.7599C0.460783 8.55382 0.5245 5.12661 2.5982 3C4.72912 0.814713 8.18404 0.814715 10.315 3.00001L11 3.70252Z",
    stroke: "#0573E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.acd64cc1c752de11fbc423ea711408a3.svg";
export { ForwardRef as ReactComponent };